export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getHouseApplyList: function getHouseApplyList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house_apply/get",
        method: "get",
        params: data
      });
    },
    getContractInfo: function getContractInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house_apply/getContractInfo",
        method: "get",
        params: data
      });
    },
    operationRefund: function operationRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house_apply/operationRefund",
        method: "post",
        data: data
      });
    }
  };
});